export function thresholdVoltage(spectrum, options = {}) {
    const { threshold = 1e-6 } = options;
    const x = spectrum.variables.x.data;
    const y = spectrum.variables.y.data;
    // Search for the first point where the x value is above the threshold
    let result = {
        index: -1,
        value: x[0],
    };
    let converged = false;
    for (let i = 0; i < x.length && !converged; i++) {
        if (y[i] > threshold) {
            result = {
                index: i,
                value: x[i],
            };
            converged = true;
        }
    }
    return converged ? result : null;
}
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoidGhyZXNob2xkVm9sdGFnZS5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy9jYWxjdWxhdGlvbnMvdGhyZXNob2xkVm9sdGFnZS50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFJQSxNQUFNLFVBQVUsZ0JBQWdCLENBQzlCLFFBQXNCLEVBQ3RCLFVBQW1DLEVBQUU7SUFFckMsTUFBTSxFQUFFLFNBQVMsR0FBRyxJQUFJLEVBQUUsR0FBRyxPQUFPLENBQUM7SUFFckMsTUFBTSxDQUFDLEdBQUcsUUFBUSxDQUFDLFNBQVMsQ0FBQyxDQUFDLENBQUMsSUFBZ0IsQ0FBQztJQUNoRCxNQUFNLENBQUMsR0FBRyxRQUFRLENBQUMsU0FBUyxDQUFDLENBQUMsQ0FBQyxJQUFnQixDQUFDO0lBRWhELHNFQUFzRTtJQUN0RSxJQUFJLE1BQU0sR0FBRztRQUNYLEtBQUssRUFBRSxDQUFDLENBQUM7UUFDVCxLQUFLLEVBQUUsQ0FBQyxDQUFDLENBQUMsQ0FBQztLQUNaLENBQUM7SUFDRixJQUFJLFNBQVMsR0FBRyxLQUFLLENBQUM7SUFDdEIsS0FBSyxJQUFJLENBQUMsR0FBRyxDQUFDLEVBQUUsQ0FBQyxHQUFHLENBQUMsQ0FBQyxNQUFNLElBQUksQ0FBQyxTQUFTLEVBQUUsQ0FBQyxFQUFFLEVBQUU7UUFDL0MsSUFBSSxDQUFDLENBQUMsQ0FBQyxDQUFDLEdBQUcsU0FBUyxFQUFFO1lBQ3BCLE1BQU0sR0FBRztnQkFDUCxLQUFLLEVBQUUsQ0FBQztnQkFDUixLQUFLLEVBQUUsQ0FBQyxDQUFDLENBQUMsQ0FBQzthQUNaLENBQUM7WUFDRixTQUFTLEdBQUcsSUFBSSxDQUFDO1NBQ2xCO0tBQ0Y7SUFDRCxPQUFPLFNBQVMsQ0FBQyxDQUFDLENBQUMsTUFBTSxDQUFDLENBQUMsQ0FBQyxJQUFJLENBQUM7QUFDbkMsQ0FBQyJ9